<template>
  <div>
    <mobile-plan-records/>
  </div>
</template>

<script>
import MobilePlanRecords from '@/components/content/_mobile/plan/records'
export default {
  name: 'mobile-plan-records-page',
  components: {
    MobilePlanRecords
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/_mobile/owner/_user/plan/records.vue